import {PostContractualTermAcceptParams} from 'domain/usecases/private/home/post-contractual-term-accept';
import {makePostContractualTermAccept} from 'main/factories/usecases/private/remote-home/post-contractual-term-accept-factory';

export const postContractualTermAccept = async (params: PostContractualTermAcceptParams) => {
	const response = await makePostContractualTermAccept().post(params);
	return response;
};
